import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from '../assets/images/avatar.png'; // Will use a placeholder or remove if not present

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          {/* We can use a generic icon or keep their image wrapper with a cool background */}
          <img src="https://avatars.githubusercontent.com/u/10000000?v=4" alt="Avatar" onError={(e) => { e.currentTarget.src = "https://ui-avatars.com/api/?name=Alain+Martial&size=256"; }} />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/amartial" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/martialmbe/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Alain Martial MBE</h1>
          <p>Ingénieur DevOps & Cloud Architect</p>
          <div className="mobile_social_icons">
            <a href="https://github.com/amartial" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/martialmbe/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <p style={{ marginTop: '20px', fontSize: '1.2rem', lineHeight: '1.6' }}>
            Bienvenue sur la présentation technique du projet <strong>Technova Solutions SISRH</strong>. 
            Ce système de gestion des ressources humaines basé sur Odoo 16 est déployé via une architecture hybride de pointe.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Main;
